'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('commercial_uses', {
      url: '/account/density/commercial_uses?jurisdiction&sta_recid',
      template: '<commercial-uses></commercial-uses>',
      authenticate: true,
      params: {
        jurisdiction: null,  // Default value if not provided
        sta_recid: null      // Default value if not provided
      }
    });
}



// WEBPACK FOOTER //
// ./client/app/account/density/commercial_uses/commercial_uses.routes.js